import React from "react";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { compose } from "recompose";
import { SnackbarProvider } from "notistack";
import DismissSnackbar from "./DismissSnackbar";
import ReadOnlyNotification from "./auth/ReadOnlyNotification";

const styles = theme => ({
  success: { backgroundColor: theme.snackbarSuccessBG, color: theme.snackbarSuccessTextColor },
  error: { backgroundColor: theme.snackbarErrorBG, color: theme.snackbarErrorTextColor },
  warning: { backgroundColor: theme.snackbarWarningBG, color: theme.snackbarWarningTextColor },
  info: { backgroundColor: theme.snackbarSuccessBG, color: theme.snackbarSuccessTextColor }
});

class StyledSnackbar extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes } = this.props;
    return (
      <>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right"
          }}
          action={key => <DismissSnackbar snackBarId={key} />}
          autoHideDuration={2000}
          classes={{
            variantSuccess: classes.success,
            variantError: classes.error,
            variantWarning: classes.warning,
            variantInfo: classes.info
          }}
        >
          {this.props.children}
          <ReadOnlyNotification />
        </SnackbarProvider>
      </>
    );
  }
}

export default compose(
  withStyles(styles),
  withTheme()
)(StyledSnackbar);
